export class Coordinate {
    longitude: number;
    latitude: number;
}
